import { useMemo } from 'react'

import { IRQCategorySeverity } from '@/gen/inventory/v1/company_service_pb'

import { riskLevelToColor } from '@/lib/ui/color'

import { Badge } from '@/components/lemmala-design-system/badge/badge'

type InherentRiskCategoriesSummaryProps = {
  irqCategorySeverities: IRQCategorySeverity[]
}

export const InherentRiskCategoriesSummary = ({
  irqCategorySeverities,
}: InherentRiskCategoriesSummaryProps) => {
  const sorted = useMemo(
    () => [...irqCategorySeverities].sort((a, b) => b.severity - a.severity),
    [irqCategorySeverities],
  )

  return (
    <div className='flex flex-col gap-3'>
      {sorted.map(({ category, severity }) => (
        <div className='flex text-nowrap' key={category}>
          <Badge badgeStyle='subtle' variant='neutral'>
            <div
              style={{ backgroundColor: riskLevelToColor[severity] }}
              className='size-1.5 rounded-full'
            />
            <div> {category}</div>
          </Badge>
        </div>
      ))}
    </div>
  )
}
